import { createSlice } from '@reduxjs/toolkit';
import { defaultReceivedPaymentSlice } from '@/redux/modules/billingManagement/receivedPayment/receivedPayment.types';
import { saveReceivedPayment } from '@/redux/modules/billingManagement/receivedPayment/receivedPayment.actions';

const receivedPaymentSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(saveReceivedPayment.pending, (slice) => {
            slice.wasSaveSuccessful = undefined;
        });
        builder.addCase(saveReceivedPayment.fulfilled, (slice) => {
            slice.wasSaveSuccessful = true;
        });
        builder.addCase(saveReceivedPayment.rejected, (slice) => {
            slice.wasSaveSuccessful = false;
        });
    },
    initialState: defaultReceivedPaymentSlice,
    name: 'receivedPayment',
    reducers: {},
});

export const { reducer: receivedPaymentReducer } = receivedPaymentSlice;
